/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  getRecentPrice.js
 */

import type { Series } from '@zcode/state-type'

export const getRecent = (series: Series | undefined) => series && series[series.length - 1]

// given a series, return the most recent price (y value)
export const getRecentPrice = (series: Series | undefined) => {
  const recent = getRecent(series)
  return recent?.y || null
}

// given a series, return the nost recent time (x value)
export const getRecentTime = (series: Series | undefined) => {
  const recent = getRecent(series)
  return recent?.x || null
}
